import { render, staticRenderFns } from "./etapa_13.vue?vue&type=template&id=0588b1c8&scoped=true&"
import script from "./etapa_13.vue?vue&type=script&lang=js&"
export * from "./etapa_13.vue?vue&type=script&lang=js&"
import style0 from "./etapa_13.vue?vue&type=style&index=0&id=0588b1c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0588b1c8",
  null
  
)

export default component.exports